/* eslint-disable @typescript-eslint/no-require-imports */
require('./src/styles/global.css')

exports.wrapPageElement = require('./gatsby-shared').wrapPageElement
